export const ToastConstants = {
  positionTopRight: 'top-right' as const,
  positionTopCenter: 'top-center' as const,
  positionBottomRight: 'bottom-right' as const,

  successDurationMs: 5000,
  errorDurationMs: 5000,

  successMinWidth: '350px',
  successPadding: '25px 20px',
  successMarginTop: '75px',
  successBoxShadow: '0 4px 12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(76, 175, 80, 0.1)',

  errorMinWidth: '150px',
  errorPadding: '25px 25px',
  errorMarginTop: '75px',
  errorBoxShadow: '0 4px 12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(244, 67, 54, 0.1)',

  fontWeight: 500,
  
  errorHeadingColor: '#333333',
  errorDescriptionColor: '#666666',
  
  contentPaddingLeft: '0px',

  mobileMarginTopPx: '50px',

  // Custom toast styling
  backgroundColor: '#fff',
  textColor: '#363636',
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  iconGap: '12px',
  
  // Animation
  transition: 'transform 180ms ease, opacity 180ms ease',
  transformVisible: 'translateY(0)',
  transformHidden: 'translateY(20px)',
  opacityVisible: 1,
  opacityHidden: 0,
  
  // Limits
  maxCustomToasts: 2,
};

